import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import api from '../utils/api'

interface Enrollment {
  id: number
  name: string
  course_id: number
  title: string
  instructor: string
  year: number
  season: string
  enrolled_at: string
  status: string
}

const MyEnrollments = () => {
  const [enrollments, setEnrollments] = useState<Enrollment[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadEnrollments()
  }, [])

  const loadEnrollments = async () => {
    try {
      const response = await api.get('/enrollments/my')
      setEnrollments(response.data)
    } catch (error) {
      console.error('수강신청 내역 로드 오류:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleCancel = async (id: number) => {
    if (!confirm('정말 수강신청을 취소하시겠습니까?')) return
    
    try {
      await api.delete(`/enrollments/${id}`)
      loadEnrollments()
    } catch (error: any) {
      alert(error.response?.data?.error || '취소에 실패했습니다.')
    }
  }

  if (loading) {
    return <div className="container"><div className="loading">로딩 중...</div></div>
  }

  return (
    <div className="container">
      <h1 style={{ marginBottom: '20px' }}>내 수강신청</h1>
      
      {enrollments.length === 0 ? (
        <div className="card">
          <p style={{ textAlign: 'center', color: '#666' }}>수강신청 내역이 없습니다.</p>
          <Link to="/courses" className="btn btn-primary" style={{ marginTop: '20px', display: 'block', textAlign: 'center' }}>
            강의 목록 보기
          </Link>
        </div>
      ) : (
        <div className="card">
          <table className="table">
            <thead>
              <tr>
                <th>강좌명</th>
                <th>교수명</th>
                <th>학년도/계절</th>
                <th>신청일</th>
                <th>상태</th>
                <th>작업</th>
              </tr>
            </thead>
            <tbody>
              {enrollments.map(enrollment => (
                <tr key={enrollment.id}>
                  <td>{enrollment.title}</td>
                  <td>{enrollment.instructor}</td>
                  <td>{enrollment.year}년 {enrollment.season}</td>
                  <td>{new Date(enrollment.enrolled_at).toLocaleDateString()}</td>
                  <td>
                    <span className={`btn ${enrollment.status === 'active' ? 'btn-success' : 'btn-secondary'}`} style={{ padding: '5px 10px', fontSize: '12px' }}>
                      {enrollment.status === 'active' ? '수강중' : '취소됨'}
                    </span>
                  </td>
                  <td>
                    {enrollment.status === 'active' && (
                      <button 
                        onClick={() => handleCancel(enrollment.id)}
                        className="btn btn-danger"
                        style={{ padding: '5px 10px', fontSize: '12px' }}
                      >
                        취소
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}

export default MyEnrollments
